export enum images_stores {
    banner_our_stores = "https://amatech-prd.azure-api.net/api/janus/files-management/ti/website/banner_our_stores.webp/beautify",
    banner_our_stores_mobile = "https://amatech-prd.azure-api.net/api/janus/files-management/ti/website/banner_our_stores_mobile.webp/beautify",
    banner_default_store = "https://amatech-prd.azure-api.net/api/janus/files-management/ti/website/banner_default_store.webp/beautify",
  }